module.exports = __webpack_public_path__ + "static/img/createDic.51d2c33.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/skillTutor/createDic.png
// module id = 4cRn
// module chunks = 1